import { DocumentAnalysisLineItemInput } from '@admiin-com/ds-graphql';

export const getAmountFromLineItems = (
  lineItems: DocumentAnalysisLineItemInput[]
) => {
  const amount = lineItems.reduce(
    (acc: number, item: DocumentAnalysisLineItemInput) =>
      acc + (item.price ?? 0),
    0
  );
  // if (amount === 0)
  //   return (bill.documentAnalysis?.task?.amount || 0) * 100 || 0;
  return amount;
};
